module.exports = __webpack_public_path__ + "static/media/jia-id.8d143ad1.jpg";